define('home/models/Activity',[
    'underscore',
    'backbone',

    'home/utils/datetimeUtils',

    'core/UniqueModel',
], function (
    _,
    Backbone,

    datetimeUtils,

    UniqueModel
) {
    'use strict';

    /**
     * An activity, represented by an actor, verb,
     * object, and target.
     */
    var Activity = Backbone.Model.extend({
        defaults: {
            version: 0,
            verb: null,
        },

        buildId: function (attributes) {
            attributes = attributes || this.attributes;  // eslint-disable-line backbone/no-model-attributes

            return this.constructor.buildId(
                attributes.actor,
                attributes.verb || this.constructor.prototype.defaults.verb,
                attributes.target,
                attributes.object
            );
        },

        parse: function (resp, options) {
            if (resp.id && options && options.objects) {
                resp = this.parseRelatedModels(resp, options.objects);
                resp.backendId = resp.id;
                // We set our own id for de-duplication via UniqueModel
                resp.id = this.buildId(resp);
            }

            return resp;
        },

        toJSON: function () {
            return _.defaults({
                actor: this.actor && this.actor.toJSON(),
                target: this.target && this.target.toJSON(),
                object: this.object && this.object.toJSON(),
                thread: this.thread && this.thread.toJSON(),

                // Deprecated
                forum: this.thread && this.thread.forum.toJSON(),
            }, Backbone.Model.prototype.toJSON.call(this));
        },

        getThread: function () {
            return this.thread;
        },

        /**
         * Returns the relative timestamp for this single activity.
         * If showing a timestamp for a group of activities, should
         * use ActivityFeedItem.getRelativeTimestamp for the group
         * of rolled up activities.
         */
        getRelativeCreatedAt: function () {
            return datetimeUtils.getRelativeDatetime(this.object.get('createdAt'));
        },
    }, {
        // Must keep this static method for backwards compatibility
        buildId: function (actor, verb, object, target) {
            return [
                actor ? actor.id : '',
                verb,
                object ? object.id : '',
                target ? target.id : '',
            ].join('|');
        },
    });

    UniqueModel.addType('Activity', Activity);

    return Activity;
});

